import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

const AddControl = ({ iconSize, label, onClick }) => (
  <a className="clickable" onClick={onClick}>
    <FontAwesomeIcon className="mr-2" icon={faPlus} size={iconSize} />
    {label}
  </a>
);

AddControl.propTypes = {
  iconSize: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default AddControl;
